import PropTypes from 'prop-types'
import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import { EMAIL_MP_AYUDA_TEXTO, EMAIL_MP_INVALIDO_TEXTO } from '../../../constants/publicaciones.js'
import styles from './PedirEmailMP.module.css'

const FORMATO_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

/**
 * Pide el mail de la cuenta de Mercado Pago con la que el vendedor va a pagar el débito automático.
 *
 * Mercado Pago ata la suscripción a una cuenta suya en el momento del alta, así que el mail tiene que
 * ser el de una cuenta existente y no lo tenemos en la base: el de e-BuyMarket no tiene por qué ser
 * el mismo. Se precarga el que haya cargado, que el vendedor puede corregir.
 *
 * @param {Object} props
 * @param {string|null} props.emailSugerido
 * @param {Function} props.onConfirmar - Recibe el mail
 * @param {Function} props.onCancelar
 * @param {boolean} [props.iniciando]
 */
const PedirEmailMP = ({ emailSugerido, onConfirmar, onCancelar, iniciando = false }) => {
  const [email, setEmail] = useState(emailSugerido ?? '')
  const [error, setError] = useState('')

  const confirmar = () => {
    const limpio = email.trim()

    if (!FORMATO_EMAIL.test(limpio)) {
      setError(EMAIL_MP_INVALIDO_TEXTO)
      return
    }

    onConfirmar(limpio)
  }

  return (
    <Modal show onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title>Tu cuenta de Mercado Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{EMAIL_MP_AYUDA_TEXTO}</p>
        <input
          type="email"
          className={styles.input}
          value={email}
          autoFocus
          placeholder="tucuenta@mail.com"
          onChange={(e) => {
            setEmail(e.target.value)
            setError('')
          }}
          onKeyDown={(e) => e.key === 'Enter' && confirmar()}
        />
        {error && <small className="warningMessage">{error}</small>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelar} disabled={iniciando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={confirmar} disabled={iniciando}>
          Continuar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

PedirEmailMP.propTypes = {
  emailSugerido: PropTypes.string,
  onConfirmar: PropTypes.func.isRequired,
  onCancelar: PropTypes.func.isRequired,
  iniciando: PropTypes.bool
}

export default PedirEmailMP
